import Input from '../../../shared/components/form/input'
import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import api from '../../../utils/api'
/* select */
import Select from 'react-select'
import SelectStyles from '../../../shared/css/SelectStyle'
/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
import Modal from '../../../shared/modal/Modal'
import Cost from '../Cost/Cost'
import NumberToMoney from '../../../shared/functions/NumberToMoney'
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"
/* Cadastro rápido: fornecedor, tecido e tipo de cor */
import NewProvider from "../../provider/NewProvider"
import NewCloth from "../../cloth/NewCloth"
import NewColorType from "../../colorType/NewColorType"
import '../../../shared/css/costItem.css'

function FormColor({ handleSubmit, colorData, costData, btnText, btCancelLink, btCancelAction, title }) {
    const [color, setColor] = useState(colorData || { cost: [] })
    const [providers, setProviders] = useState([])
    const [cloths, setCloths] = useState([])
    const [colorTypes, setColorTypes] = useState([])
    const [token] = useState(localStorage.getItem('token') || '')
    const [modalCost, setModalCost] = useState(false)
    const [cost, setCost] = useState(costData || [])
    const { setFlashMessage } = useFlashMessage()

    /* Cadastro rápido */
    const [modalProvider, setModalProvider] = useState(false)
    const [modalCloth, setModalCloth] = useState(false)
    const [modalColorType, setModalColorType] = useState(false)

    const getSelectInfo = () => {
        api.get('/color/getall', {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        })
            .then((response) => {
                if (response) {
                    setProviders(response.data.providers)
                    setCloths(response.data.cloths)
                    setColorTypes(response.data.colorTypes)
                }
            })
    }

    useEffect(() => {
        getSelectInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    function handleOnChange(e) {
        setColor({ ...color, [e.target.name]: e.target.value })
    }

    const handleSelectChange = (selectedOption) => {
        setColor({ ...color, [selectedOption.selectName]: selectedOption })
    }

    async function submit(e) {
        e.preventDefault()

        //validations
        if (!color.provider) {
            setFlashMessage("O Fornecedor é obrigatório", 'error')
            return
        }
        if (!color.cloth) {
            setFlashMessage("O Tecido é obrigatório", 'error')
            return
        }
        if (!color.name) {
            setFlashMessage("O Nome é obrigatório", 'error')
            return
        }
        if (!cost.length) {
            setFlashMessage("O custo do tecido é obrigatório", 'error')
            return
        }

        let data = color
        data.cost = cost
        handleSubmit(data)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection label="Identificação">
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Fornecedor:
                            <div onClick={() => { setModalProvider(true) }}>
                                <div className="plus-sinal" >
                                    <div className="plus-sinal-tip"></div>
                                    <div className="plus-sinal-middle"></div>
                                    <div className="plus-sinal-tip"></div>
                                </div>
                            </div>
                        </label>
                        <Select
                            options={providers}
                            styles={SelectStyles}
                            onChange={handleSelectChange}
                            value={color.provider || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Tecido:
                            <div onClick={() => { setModalCloth(true) }}>
                                <div className="plus-sinal" >
                                    <div className="plus-sinal-tip"></div>
                                    <div className="plus-sinal-middle"></div>
                                    <div className="plus-sinal-tip"></div>
                                </div>
                            </div>
                        </label>
                        <Select
                            options={cloths}
                            styles={SelectStyles}
                            onChange={handleSelectChange}
                            value={color.cloth || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <label className="input-label">Tipo de Cor:
                            <div onClick={() => { setModalColorType(true) }}>
                                <div className="plus-sinal" >
                                    <div className="plus-sinal-tip"></div>
                                    <div className="plus-sinal-middle"></div>
                                    <div className="plus-sinal-tip"></div>
                                </div>
                            </div>
                        </label>
                        <Select
                            options={colorTypes}
                            styles={SelectStyles}
                            onChange={handleSelectChange}
                            value={color.colorType || ""}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Nome"
                            type="text"
                            name="name"
                            value={color.name || ""}
                            handleOnChange={handleOnChange}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Referencia"
                            type="text"
                            name="ref"
                            value={color.ref || ""}
                            handleOnChange={handleOnChange}
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection label="Custo por unidade">
                <div className="fl-row">
                    <div className="form-group">
                        <label className="input-label">Faixas de custo:
                            <div onClick={() => { setModalCost(true) }}>
                                <div className="plus-sinal" >
                                    <div className="plus-sinal-tip"></div>
                                    <div className="plus-sinal-middle"></div>
                                    <div className="plus-sinal-tip"></div>
                                </div>
                            </div>
                        </label>
                        <div className="List">
                            {
                                cost.map((item) =>
                                    <div className="cost-item-row" key={item._id}>
                                        <div className="cost-item-columns">
                                            <span className="cost-item-description">{item.description || '—'}</span>
                                            <span className="cost-item-range">Entre {item.minUnit} e {item.maxUnit} unidades</span>
                                            <span className="cost-item-value">R$ {NumberToMoney(item.cost)}</span>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </FormSection>

            {/* MODAL CUSTO */}
            <Modal
                modalStatus={modalCost}
                changeStatus={setModalCost}
                w={92}
                t={3}
                h={90}
                content={
                    <Cost selectItem={true} handleOnSelectItem={(data) => { setCost(data) }} selectedData={cost} btCancelAction={() => setModalCost(false)} />
                }
            />

            {/* MODAIS DE CADASTRO RÁPIDO */}
            <Modal
                modalStatus={modalProvider}
                changeStatus={setModalProvider}
                w={80}
                content={
                    <NewProvider btCancelAction={() => setModalProvider(false)} handleOnSuccess={() => { setModalProvider(false); getSelectInfo() }} />
                }
            />
            <Modal
                modalStatus={modalCloth}
                changeStatus={setModalCloth}
                w={80}
                content={
                    <NewCloth btCancelAction={() => setModalCloth(false)} handleOnSuccess={() => { setModalCloth(false); getSelectInfo() }} />
                }
            />
            <Modal
                modalStatus={modalColorType}
                changeStatus={setModalColorType}
                w={80}
                content={
                    <NewColorType btCancelAction={() => setModalColorType(false)} handleOnSuccess={() => { setModalColorType(false); getSelectInfo() }} />
                }
            />
        </FormLayout>
    )
}

export default FormColor
